<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')" v-if="pageMap.handle.insert">新增</el-button>
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right" v-if="pageMap.filter">
                <el-input v-for="item in pageMap.filter" v-model="filterParams[item.prop]" :placeholder="'请输入' + item.label" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column v-for="column in pageMap.table" :label="column.label" :key="column.prop" :width="column.width">
                <template slot-scope="scope"> 
                    <span v-if="column.type == 'text'">{{ scope.row[column.prop] }}</span>
                    <span v-if="column.type == 'enum'">{{ getEnumLabel('status', scope.row[column.prop]) }}</span>
                    <span v-if="column.type == 'date'">{{ convertToDate(scope.row[column.prop]) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small" v-if="pageMap.handle.update">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small" v-if="pageMap.handle.delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item v-for="item in pageMap.form" :label="item.label">
                        <el-input v-model="handleInfo[item.prop]" :type="item.type" v-if="item.type == 'text' || item.type == 'textarea' || item.type == 'password'"></el-input>
                        <el-select v-model="handleInfo[item.prop]" placeholder="请选择" style="width: 100%;" v-if="item.type == 'enum' || item.type == 'reference'">
                            <el-option v-for="option in getEnumArray(item.enum)" :label="option.label" :value="option.value" v-if="item.type == 'enum'"></el-option>
                            <el-option v-for="option in referenceMap[item.reference]" :label="option[item.referenceLabel]" :value="option[item.referenceValue]" v-if="item.type == 'reference'"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

export default {
    mixins: [verifyMixin, listMixin]
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>